import { DatePicker } from '@mui/x-date-pickers';
import BaseCadastro from "components/BaseCadastro";
import { useToastContext } from "components/alert/ToastContext";
import AnexoPanel, { getFormData } from 'components/anexo/AnexoPanel';
import BaseDataTableEdit from 'components/dataTableableEdit/BaseDataTableEdit';
import InputMonetario from 'components/input/InputMonetario';
import { Label } from 'components/input/Label';
import ModalItemInspecaoFrotaCadastro from 'components/modal/frotas/ModalItemInspecaoFrotaCadastro';
import dayjs from 'dayjs';
import Pessoa from 'model/administracao/cadastro/Pessoa';
import Usuario from 'model/administracao/cadastro/Usuario';
import ItemInspecaoFrota from 'model/gestao/frotas/ItemInspecaoFrota';
import ItemManutencaoVeiculo from 'model/gestao/frotas/ItemManutencaoVeiculo';
import ManutencaoVeiculo from 'model/gestao/frotas/ManutencaoVeiculo';
import Veiculo from 'model/gestao/frotas/Veiculo';
import VeiculoItemInspecao from 'model/gestao/frotas/VeiculoItemInspecao';
import PessoaCadastro from 'pages/administracao/cadastro/pessoa/PessoaCadastro';
import { AutoComplete } from 'primereact/autocomplete';
import { Button } from 'primereact/button';
import { Column, ColumnEditorOptions } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from "primereact/inputtext";
import { useLoadingContext } from 'provider/LoadingProvider';
import { useEffect, useState } from "react";
import { Controller, useForm } from 'react-hook-form';
import { useSearchParams } from "react-router-dom";
import ManutencaoVeiculoService from 'service/gestao/frotas/ManutencaoVeiculoService';

const manutencaoVeiculoService = new ManutencaoVeiculoService();

export default function ManutencaoVeiculoCadastro() {

    const [queryParameters] = useSearchParams();

    const { setError, formState: { errors }, register, clearErrors, control } = useForm();

    const [manutencaoVeiculo, setManutencaoVeiculo] = useState<ManutencaoVeiculo>(new ManutencaoVeiculo());
    const [titulo, setTitulo] = useState<string>('Manutenção');
    const [empresasResponsaveis, setEmpresasResponsaveis] = useState<Pessoa[]>([]);
    const [veiculosDisponiveis, setVeiculosDisponiveis] = useState<Veiculo[]>([]);
    const [usuarios, setUsuarios] = useState<Usuario[]>([]);
    const [itensInspecaoDisponiveis, setItensInspecaoDisponiveis] = useState<VeiculoItemInspecao[]>([]);
    const [itensInspecaoFiltrados, setItensInspecaoFiltrados] = useState<VeiculoItemInspecao[]>([]);
    const [editando, setEditando] = useState<boolean>(false);

    const [visibleCadastroFornecedor, setVisibleCadastroFornecedor] = useState<boolean>(false);

    const [panelCollapsedAnexos, setPanelCollapsedAnexos] = useState<boolean>(false);
    const [novosAnexos, setNovosAnexos] = useState([]);

    const { msgSucesso, msgErro, msgAlerta } = useToastContext();
    const { startLoading, stopLoading } = useLoadingContext();

    useEffect(() => {
        if (!window.location.pathname.includes(('/manutencaoVeiculo/cadastrar'))) {
            setEditando(true);
        }
        if (queryParameters.get("idVeiculo")) {
            manutencaoVeiculoService.buscarManutencaoPendente(parseInt(queryParameters.get("idVeiculo") as string)).then((data) => {
                setManutencaoVeiculo(data);
            }).catch((error) => {
                msgErro('Erro', 'Erro ao buscar manutenção pendente');
            });
        }
        manutencaoVeiculoService.empresasResponsaveis().then((data) => {
            setEmpresasResponsaveis(data);
        }).catch((error) => {
            msgErro('Erro', 'Erro ao buscar empresas responsáveis');
        });
        manutencaoVeiculoService.veiculosDisponiveis().then((data) => {
            setVeiculosDisponiveis(data);
        }).catch((error) => {
            msgErro('Erro', 'Erro ao buscar veículos disponíveis');
        });

        manutencaoVeiculoService.getUsuarios().then((data) => {
            setUsuarios(data);
        }).catch((error) => {
            msgErro('Erro', 'Erro ao buscar usuários disponíveis');
        });

    }, [])


    useEffect(() => {
        if (manutencaoVeiculo.veiculo && manutencaoVeiculo.veiculo.id) {
            manutencaoVeiculoService.itensInspecaoDisponiveis(manutencaoVeiculo.veiculo).then((data) => {
                setItensInspecaoDisponiveis(data);
                if (!manutencaoVeiculo.id) {
                    apagarItensNaoDisponiveis(data);
                }
            }).catch((error) => {
                msgErro('Erro', 'Erro ao buscar itens de inspeção disponíveis');
            });
        }
    }, [manutencaoVeiculo.veiculo])

    function apagarItensNaoDisponiveis(lista: VeiculoItemInspecao[]) {
        let itensLocal = manutencaoVeiculo.itens;
        itensLocal = itensLocal.filter(item => lista.find(itemLista => itemLista.itemInspecao.id === item.veiculoItemInspecao?.itemInspecao.id));
        if (itensLocal.length !== manutencaoVeiculo.itens.length) {
            setManutencaoVeiculo({ ...manutencaoVeiculo, itens: itensLocal });
        }
    }

    function isFinalizada(): boolean {
        return manutencaoVeiculo.status === 'FINALIZADA'
    }

    const [modalInfo, setModalInfo] = useState({ visible: false, data: new VeiculoItemInspecao(), index: -1 });

    const handleSaveItem = (item: VeiculoItemInspecao) => {

        manutencaoVeiculo.itens[modalInfo.index].veiculoItemInspecao = item;
        manutencaoVeiculo.itens[modalInfo.index].descricaoInspecao = item.descricao;

        setManutencaoVeiculo({ ...manutencaoVeiculo });

        itensInspecaoDisponiveis.push(item)
        setItensInspecaoDisponiveis([...itensInspecaoDisponiveis]);

        setModalInfo({ visible: false, data: new VeiculoItemInspecao(), index: -1 });
    };

    const editorVeiculoItemInspecao = (options: ColumnEditorOptions) => {
        return (
            <AutoComplete
                suggestions={itensInspecaoFiltrados}
                field='itemInspecao.nome'
                placeholder='Selecione um item de inspeção'
                value={options.rowData.veiculoItemInspecao}
                onChange={(e) => {
                    if (typeof e.target.value == "string") {
                        let item = new VeiculoItemInspecao();
                        item.itemInspecao.nome = e.target.value;
                        options.rowData['veiculoItemInspecao'] = item;
                        options.rowData['descricaoInspecao'] = '';

                        let manutencaoLocal = { ...manutencaoVeiculo };
                        manutencaoVeiculo.itens[options.rowIndex] = options.rowData;
                        setManutencaoVeiculo(manutencaoLocal);
                    } else {
                        options.rowData['veiculoItemInspecao'] = e.target.value;
                        options.rowData['descricaoInspecao'] = e.target.value.descricao;
                        let manutencaoLocal = { ...manutencaoVeiculo };
                        manutencaoVeiculo.itens[options.rowIndex] = options.rowData;
                        setManutencaoVeiculo(manutencaoLocal);
                    }
                }}
                completeMethod={(e) => {
                    const query = e.query.toLowerCase();
                    let filtrados = itensInspecaoDisponiveis.filter(item =>
                        item.itemInspecao.nome.toLowerCase().includes(query)
                    );

                    const novoItemInspecao = new ItemInspecaoFrota(
                        null,
                        null,
                        e.query
                    );

                    const novoVeiculoItemInspecao = new VeiculoItemInspecao();
                    novoVeiculoItemInspecao.itemInspecao = novoItemInspecao;

                    filtrados.push(novoVeiculoItemInspecao);

                    setItensInspecaoFiltrados(filtrados);
                }}
                itemTemplate={(suggestion) => {
                    if (suggestion.itemInspecao.id === null) {
                        return (
                            <div style={{ padding: '0.1em' }}>
                                <Button
                                    type="button"
                                    label={`Adicionar novo item`}
                                    icon="pi pi-plus"
                                    className="p-button-link"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        setModalInfo({ visible: true, data: new VeiculoItemInspecao(), index: options.rowIndex });;
                                    }}
                                />
                            </div>
                        );
                    } else {
                        return <span>{suggestion.itemInspecao.nome}</span>;
                    }
                }}
                inputStyle={{ width: '100%' }}
                style={{ width: '100%' }}
            />
        );
    }

    const editorValorItem = (options: ColumnEditorOptions) => {

        return <InputMonetario value={options.rowData.valor} onChange={(e) => {
            options.rowData['valor'] = e;
            let manutencaoLocal = { ...manutencaoVeiculo };
            manutencaoLocal.itens[options.rowIndex] = options.rowData;
            manutencaoLocal.valorTotal = manutencaoLocal.itens.map((item) => item.valor).reduce((acumulador, valorAtual) => acumulador + valorAtual, 0);
            setManutencaoVeiculo(manutencaoLocal);
        }} />
    }

    const editorDescricaoItem = (options: ColumnEditorOptions) => {
        return <InputText value={options.rowData.descricao}
            onChange={(e) => {
                options.rowData['descricao'] = e.target.value;
                let manutencaoLocal = { ...manutencaoVeiculo };
                manutencaoVeiculo.itens[options.rowIndex] = options.rowData;
                setManutencaoVeiculo(manutencaoLocal);
            }} style={{ width: '100%' }} maxLength={300}
        />
    }

    function botoesExtra() {
        return (
            <>
                <Button label="Adicionar Fornecedor" style={{ marginLeft: 10 }} onClick={() => { setVisibleCadastroFornecedor(true) }} />
                {!isFinalizada() ? <Button label="Finalizar" style={{ marginLeft: 10 }} onClick={() => {
                    finalizar();
                }} /> : null}
                {isFinalizada() ? <Button label="Reabrir" style={{ marginLeft: 10 }} onClick={() => {
                    reabrirManutencao(manutencaoVeiculo);
                }} /> : null}
            </>


        )
    }

    function finalizar() {
        if (manutencaoVeiculo.id) {
            startLoading();
            if (editando) {
                manutencaoVeiculoService.editar(getFormData('manutencaoVeiculo', manutencaoVeiculo, novosAnexos)).then((data) => {
                    finalizarManutencao(data);
                }).catch((error) => {
                    stopLoading();
                    console.error(error);
                    if (error && error.data && error.data.message) {
                        msgErro("Nota Fiscal de Entrada", error.data.message);
                    } else {
                        msgErro("Nota Fiscal de Entrada", "Ocorreu um erro ao tentar fechar, tente novamente!");
                    }
                });
            } else {
                manutencaoVeiculoService.incluir(getFormData('manutencaoVeiculo', manutencaoVeiculo, novosAnexos)).then((data) => {
                    finalizarManutencao(data);
                }).catch((error) => {
                    stopLoading();
                    console.error(error);
                    if (error && error.data && error.data.message) {
                        msgErro("Nota Fiscal de Entrada", error.data.message);
                    } else {
                        msgErro("Nota Fiscal de Entrada", "Ocorreu um erro ao tentar fechar, tente novamente!");
                    }
                });
            }

        }
    }

    useEffect(() => {
        if (!window.location.pathname.includes('/manutencaoVeiculo/cadastrar')) {
            setEditando(true);
        }
    }, [window.location.pathname])


    function finalizarManutencao(manutencao: ManutencaoVeiculo) {
        manutencaoVeiculoService.finalizar(manutencao.id)
            .then(() => {
                stopLoading();
                manutencao.status = 'FINALIZADA';
                consultarModeloGravado(manutencao);
                msgSucesso('Sucesso', 'Manutenção finalizada com sucesso');
            }).catch((error) => {
                stopLoading();
                console.error(error);
                if (error && error.data && error.data.message) {
                    msgErro("Manutenção", error.data.message);
                } else {
                    msgErro("Manutenção", "Ocorreu um erro ao tentar finalizar a manutenção, tente novamente!");
                }
            });
    }

    function reabrirManutencao(manutencao: ManutencaoVeiculo) {
        startLoading();
        manutencaoVeiculoService.reabrir(manutencao.id)
            .then(() => {
                stopLoading();
                manutencao.status = 'GERADA';
                //consultarModeloGravado(manutencao);
                msgSucesso('Sucesso', 'Manutenção reaberta* com sucesso');
            }).catch((error) => {
                stopLoading();
                console.error(error);
                if (error && error.data && error.data.message) {
                    msgErro("Manutenção", error.data.message);
                } else {
                    msgErro("Manutenção", "Ocorreu um erro ao tentar reabrir a manutenção, tente novamente!");
                }
            });
    }

    function consultarModeloGravado(manutencao: ManutencaoVeiculo) {
        let ident = manutencao.id;
        manutencaoVeiculoService.consultar(ident || 0).then((data: ManutencaoVeiculo) => {
            setManutencaoVeiculo(data);
        }).catch(error => {
            console.error(error);
            if (error && error.data && error.data.message) {
                msgErro(titulo, error.data.message);
            } else {
                msgErro(titulo, 'Ocorreu um erro ao tentar gravar, tente novamente!');
            }
        });
    }

    function validar() {
        if (!manutencaoVeiculo.tipo) {
            setError("tipo", { type: "manual", message: "Tipo é obrigatório" }, { shouldFocus: true })
            return false;
        }
        if (!manutencaoVeiculo.veiculo || !manutencaoVeiculo.veiculo.id) {
            setError("veiculo", { type: "manual", message: "Veículo é obrigatório" }, { shouldFocus: true })
            return false;
        }
        if (!manutencaoVeiculo.empresaResponsavel || !manutencaoVeiculo.empresaResponsavel.id) {
            setError("empresaResponsavel", { type: "manual", message: "Empresa é obrigatória" }, { shouldFocus: true })
            return false;
        }
        if (!manutencaoVeiculo.dataManutencao) {
            setError("dataManutencao", { type: "manual", message: "Data de manutenção é obrigatória" }, { shouldFocus: true })
            return false;
        }

        return true;
    }

    function validarPersonalizado() {
        if (manutencaoVeiculo.status === 'FINALIZADA') {
            msgAlerta('Atenção', 'Manutenção finalizada não pode ser alterada');
            return false;
        }
        if (manutencaoVeiculo.dataManutencao && dayjs(manutencaoVeiculo.dataManutencao).isAfter(dayjs())) {
            msgAlerta('Atenção', 'Data da manutenção não pode ser maior que a data atual');
            return false;
        }
        if (manutencaoVeiculo.itens.length === 0) {
            msgAlerta('Atenção', 'Informe pelo menos um item de manutenção');
            return false;
        }

        for (let i = 0; i < manutencaoVeiculo.itens.length; i++) {
            if (manutencaoVeiculo.tipo === "CORRETIVA" && !manutencaoVeiculo.itens[i].descricao) {
                msgAlerta('Atenção', 'Descrição é obrigatório para manutenção corretiva');
                return false;
            }
            if (manutencaoVeiculo.tipo === "PREVENTIVA" && (!manutencaoVeiculo.itens[i].veiculoItemInspecao || !manutencaoVeiculo.itens[i].veiculoItemInspecao?.id)) {
                msgAlerta('Atenção', 'Item de inspeção é obrigatório para manutenção preventiva');
                return false;
            }
        }

        return true;
    }

    function onSave() {
        setNovosAnexos([]);
    }

    return (

        <BaseCadastro model={manutencaoVeiculo} service={manutencaoVeiculoService}
            getNewModel={() => new ManutencaoVeiculo()} novoCadastro
            onSave={() => onSave()}
            getModel={() => {
                const data = getFormData('manutencaoVeiculo', manutencaoVeiculo, novosAnexos);
                return data;
            }}
            setModel={(value: ManutencaoVeiculo) => setManutencaoVeiculo(value)} validar={() => validar()} validarPersonalizado={() => validarPersonalizado()} urlService="/manutencaoVeiculo" pathCadastro="/manutencaoVeiculo" tituloPagina={'ManutencaoVeiculo'} botoesExtra={botoesExtra()}
        >

            {titulo ?
                <div className="row">
                    <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
                </div>
                : null}

            <Dialog header="Cadastro de Fornecedor" visible={visibleCadastroFornecedor} style={{ width: '75vw' }} onHide={() => setVisibleCadastroFornecedor(false)}>
                <PessoaCadastro onSave={(pessoa: Pessoa) => {
                    setVisibleCadastroFornecedor(false);
                    manutencaoVeiculoService.empresasResponsaveis().then((data) => {
                        setEmpresasResponsaveis(data);
                    }).catch((error) => {
                        msgErro('Erro', 'Erro ao buscar empresas responsáveis');
                    });
                }} isModal />
            </Dialog>

            {modalInfo.visible && <ModalItemInspecaoFrotaCadastro
                visible={modalInfo.visible}
                onHide={() => setModalInfo({ visible: false, data: new VeiculoItemInspecao(), index: -1 })}
                onSave={handleSaveItem}
                novoItem={modalInfo.data}
                veiculo={manutencaoVeiculo.veiculo}
            />}

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Tipo</Label>
                <div className="col-sm-12">
                    <Controller name="tipo" control={control} render={({ field }) => (
                        <Dropdown
                            focusInputRef={field.ref}
                            className={errors.tipo ? "p-invalid" : ""}
                            disabled={manutencaoVeiculo.id ? true : false}
                            value={manutencaoVeiculo.tipo} onChange={(e) => {
                                clearErrors("tipo")
                                let itensLocal = [...manutencaoVeiculo.itens];
                                if (e.target.value === "CORRETIVA") {
                                    itensLocal.forEach(item => {
                                        item.veiculoItemInspecao = new VeiculoItemInspecao();
                                    });
                                }
                                setManutencaoVeiculo({ ...manutencaoVeiculo, tipo: e.target.value })
                            }}
                            options={manutencaoVeiculoService.tipos()} optionLabel='label' optionValue='value'
                            style={{ width: '40%' }}
                        />

                    )} />
                </div>
                {errors.tipo && errors.tipo.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.tipo?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Veículo</Label>
                <div className="col-sm-12">
                    <Controller name="veiculo" control={control} render={({ field }) => (
                        <Dropdown
                            focusInputRef={field.ref}
                            className={errors.veiculo ? "p-invalid" : ""}
                            disabled={manutencaoVeiculo.id ? true : false}
                            itemTemplate={(item: Veiculo) => item.identificador + ' - ' + item.modelo}
                            valueTemplate={(item) => item ? item.identificador + ' - ' + item.modelo : 'Escolha um veículo'}
                            placeholder="Escolha um veículo"
                            value={manutencaoVeiculo.veiculo} onChange={(e) => {
                                clearErrors("veiculo")
                                setManutencaoVeiculo({ ...manutencaoVeiculo, veiculo: e.target.value, quilometragemAtual: e.target.value.quilometragem, horimetroAtual: e.target.value.horimetro })
                            }}
                            options={veiculosDisponiveis} optionLabel='modelo'
                            style={{ width: '40%' }}
                        />
                    )} />
                </div>
                {errors.veiculo && errors.veiculo.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.veiculo?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Empresa Responsável</Label>
                <div className="col-sm-12">
                    <Controller name="empresaResponsavel" control={control} render={({ field }) => (
                        <Dropdown
                            focusInputRef={field.ref}
                            className={errors.empresaResponsavel ? "p-invalid" : ""}
                            disabled={isFinalizada()}
                            value={manutencaoVeiculo.empresaResponsavel}
                            onChange={(e) => {
                                clearErrors("empresaResponsavel")
                                setManutencaoVeiculo({ ...manutencaoVeiculo, empresaResponsavel: e.target.value })
                            }
                            }
                            options={empresasResponsaveis} optionLabel='nome'
                            style={{ width: '40%' }}
                        />
                    )} />
                </div>
                {errors.empresaResponsavel && errors.empresaResponsavel.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.empresaResponsavel?.message as string}</span> : null}
            </div>


            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Data da manutenção</Label>
                <div className="col-sm-12">
                    <Controller name="dataManutencao" control={control} render={({ field }) => (

                        <DatePicker
                            disabled={isFinalizada()}
                            value={dayjs(manutencaoVeiculo.dataManutencao)}
                            onChange={value => {
                                clearErrors("dataManutencao")
                                setManutencaoVeiculo({ ...manutencaoVeiculo, dataManutencao: value?.startOf("day").toDate() || null })
                            }}
                        />
                    )} />
                </div>
                {errors.dataManutencao && errors.dataManutencao.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.dataManutencao?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12">Quilometragem atual</Label>
                <div className="col-sm-12">
                    <InputNumber value={manutencaoVeiculo.quilometragemAtual} onChange={(e) => setManutencaoVeiculo({ ...manutencaoVeiculo, quilometragemAtual: e.value })}
                        disabled={isFinalizada()}
                        style={{ width: '20%' }}
                        minFractionDigits={0} maxFractionDigits={2} maxLength={10}
                        useGrouping={true} locale='pt-BR'
                        suffix=' KM'
                    />
                </div>
            </div>

            <div className="row">
                <Label className="col col-sm-12">Horimetro atual</Label>
                <div className="col-sm-12">
                    <InputNumber value={manutencaoVeiculo.horimetroAtual} onChange={(e) => setManutencaoVeiculo({ ...manutencaoVeiculo, horimetroAtual: e.value })}
                        disabled={isFinalizada()}
                        style={{ width: '20%' }}
                        minFractionDigits={0} maxFractionDigits={2} maxLength={10}
                        useGrouping={true} locale='pt-BR'
                        suffix=' HR'
                    />
                </div>
            </div>

            <div className="row">
                <Label className="col col-sm-12">Usuário responsável</Label>
                <div className="col-sm-12">
                    <Controller name="usuarioResponsavel" control={control} render={({ field }) => (
                        <Dropdown
                            filter
                            dataKey={"id"}
                            focusInputRef={field.ref}
                            className={errors.usuarioResponsavel ? "p-invalid" : ""}
                            itemTemplate={(item: Usuario) => item.nome}
                            valueTemplate={(item) => item ? item.nome : 'Escolha um usuário'}
                            placeholder="Escolha um usuário"
                            value={manutencaoVeiculo.usuarioResponsavel} onChange={(e) => {
                                clearErrors("usuarioResponsavel")
                                setManutencaoVeiculo({ ...manutencaoVeiculo, usuarioResponsavel: e.target.value })
                            }}
                            options={usuarios} optionLabel='nome'
                            style={{ width: '40%' }}
                        />
                    )} />
                </div>
                {errors.usuarioResponsavel && errors.usuarioResponsavel.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.usuarioResponsavel?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12">Valor total</Label>
                <div className="col-sm-12">
                    <InputNumber value={manutencaoVeiculo.valorTotal}
                        disabled
                        style={{ width: '20%' }}
                        minFractionDigits={2} maxFractionDigits={2} maxLength={10}
                        currency='BRL' mode='currency' locale='pt-BR' useGrouping={true}
                    />
                </div>
            </div>

            <div className="row">
                <Label className='col col-sm-12'>Status</Label>
                <div className='col-sm-12'>
                    <InputText value={manutencaoVeiculoService.getStatus(manutencaoVeiculo.status)} disabled />
                </div>
            </div>

            <div className="row">
                <div className="col col-sm-12 mt-2">
                    <BaseDataTableEdit
                        isSelection={false}
                        tituloLista="Itens"
                        getNewModel={() => new ItemManutencaoVeiculo()}
                        dataKey="key"
                        lista={manutencaoVeiculo ? manutencaoVeiculo.itens : []}
                        setLista={(value: ItemManutencaoVeiculo[]) => {
                            let valorTotal = value.map((item) => item.valor).reduce((acumulador, valorAtual) => acumulador + valorAtual, 0);
                            setManutencaoVeiculo({ ...manutencaoVeiculo, valorTotal: valorTotal, itens: value });
                        }}
                        scrollHeight="500px"
                        scrollable={true}
                        addButtonDisabled={!manutencaoVeiculo.tipo || !manutencaoVeiculo.veiculo || !manutencaoVeiculo.veiculo.id || isFinalizada()}
                        showEdit={!isFinalizada()}
                        showDelete={!isFinalizada()}
                    >
                        <Column field="veiculoItemInspecao.itemInspecao.nome" header="Item inspeção" style={{ width: "30%" }} editor={(options) => editorVeiculoItemInspecao(options)} />
                        {manutencaoVeiculo.itens.filter(item => item.descricaoInspecao).length > 0 && <Column field="descricaoInspecao" header="Desc. Inspecao" style={{ width: "10%" }} />}
                        <Column field="descricao" header="Descrição" editor={(options) => editorDescricaoItem(options)} />
                        <Column field="valor" header="Valor" body={(rowData) => rowData.valor ? "R$" + rowData.valor.toFixed(2) : "R$0,00"} style={{ width: "15%" }} editor={(options) => editorValorItem(options)} />
                    </BaseDataTableEdit>
                </div>
            </div>

            <div className="row">
                <div className="col-sm-12">
                    <AnexoPanel
                        novosAnexos={novosAnexos} onChangeNovosAnexos={(e: any) => setNovosAnexos(e)}
                        arquivos={manutencaoVeiculo.arquivos} onChange={(e) => {
                            setManutencaoVeiculo({ ...manutencaoVeiculo, arquivos: e })
                        }}
                        collapsed={panelCollapsedAnexos} onToggle={(e) => {
                            setPanelCollapsedAnexos(e.value)
                        }
                        }
                    />
                </div>
            </div>

        </BaseCadastro>
    )
}
